import React from "react";
import { motion } from "framer-motion";
import { Check, ShieldCheck } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { COURSE } from "../../data/course";

const inr = (n) => `₹${n.toLocaleString("en-IN")}`;

export default function CourseFee() {
  const { fee } = COURSE;

  return (
    <section id="fees" data-testid="fees-section" className="relative overflow-hidden py-24 md:py-32">
      <div className="pointer-events-none absolute left-1/2 top-24 h-[380px] w-[380px] -translate-x-1/2 glow-blue opacity-40" />

      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="mx-auto max-w-2xl text-center">
          <Reveal>
            <Eyebrow className="justify-center">Course Fee</Eyebrow>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-display text-4xl font-semibold leading-[1.05] tracking-tight text-[#293891] sm:text-5xl">
              One straightforward price. <span className="text-[#e63329]">All the value.</span>
            </h2>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <motion.div
            whileHover={{ y: -4 }}
            transition={{ type: "spring", stiffness: 200, damping: 20 }}
            className="mx-auto mt-14 max-w-2xl overflow-hidden rounded-3xl border border-[#293891]/10 bg-white shadow-[0_30px_80px_-40px_rgba(41,56,145,0.4)]"
            data-testid="fee-card"
          >
            <div className="p-8 md:p-10">
              {/* Single price */}
              <div className="text-center sm:text-left">
                <p className="text-xs uppercase tracking-[0.2em] text-[#566076]">Course Fee</p>
                <div
                  className="mt-3 font-display text-5xl font-semibold leading-none text-[#293891] md:text-6xl"
                  data-testid="course-price"
                >
                  {inr(fee.price)}
                </div>
                <p className="mt-2 text-sm text-[#566076]">{fee.note}</p>
              </div>

              {/* Honest-pricing tagline */}
              <div
                className="mt-6 flex items-start gap-3 rounded-2xl border border-[#293891]/10 bg-[#F5F7FC] p-5"
                data-testid="pricing-tagline"
              >
                <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#3B82F6]/12 text-[#3B82F6]">
                  <ShieldCheck size={16} />
                </span>
                <p className="text-sm leading-relaxed text-[#3A4152]">{fee.tagline}</p>
              </div>

              {/* Highlights */}
              <div className="mt-8 space-y-3">
                {fee.highlights.map((item) => (
                  <div key={item} className="flex items-start gap-3">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#3B82F6]/12 text-[#3B82F6]">
                      <Check size={13} />
                    </span>
                    <span className="text-sm text-[#3A4152]">{item}</span>
                  </div>
                ))}
              </div>

              {/* Enrollment note */}
              <div className="mt-8 rounded-2xl border border-[#293891]/10 bg-[#F5F7FC] p-6">
                <span className="text-xs font-semibold uppercase tracking-[0.18em] text-[#e63329]">Enrollment</span>
                <p className="mt-2 font-display text-base font-medium leading-snug text-[#293891]">{fee.enrollmentNote}</p>
              </div>
            </div>
          </motion.div>
        </Reveal>
      </div>
    </section>
  );
}
